import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LoginRequest, LoginResponse } from '../../models/auth/login';
import { AppUtil } from '../../utility/app-util';
import { Role, RolesResponse, Institution, InstitutionsResponse } from '../../models/auth/perfil';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private url = AppUtil.addTrailingSlash(environment.URL_API_AUTH) + 'api/user/';

    constructor(private http: HttpClient) { }

    login(credentials: LoginRequest): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(`${this.url}login`, credentials);
    }

    listarInstituciones(usuarioId: string): Observable<InstitutionsResponse> {
        return this.http.get<InstitutionsResponse>(`${this.url}institutions/${usuarioId}`);
    }

    listarRoles(usuarioId: string, institutionId: string): Observable<RolesResponse> {
        return this.http.get<RolesResponse>(`${this.url}roles/${usuarioId}/${institutionId}`);
    }

    asignarRol(userId: string, institutionId: string, roleId: string): Observable<any> {
        return this.http.post<any>(`${this.url}role/add`, { userId, institutionId, roleId });
    }

    deactivarRol(userRoleId: string): Observable<any> {
        return this.http.post<any>(`${this.url}role/${userRoleId}/deactivate`, {});
    }

    changeToken(institutionId: string, roleId: string): Observable<any> {
        return this.http.post<any>(`${this.url}change-token`, { institutionId, roleId });
    }

    generarToken(roleId: string, institutionId: string): Observable<any> {
        return this.http.get<any>(`${this.url}generar-token?role_id=${roleId}&institution_id=${institutionId}`);
    }

    changePassword(data: any): Observable<any> {
        return this.http.put<any>(`${this.url}change-password`, data);
    }


    // Tables
    listarTablesRoles(): Observable<RolesResponse> {
        return this.http.get<RolesResponse>(`${AppUtil.addTrailingSlash(environment.URL_API_AUTH)}api/tables/roles`);
    }

    listarTablesInstitutions(): Observable<InstitutionsResponse> {
        return this.http.get<InstitutionsResponse>(`${AppUtil.addTrailingSlash(environment.URL_API_AUTH)}api/tables/institutions`);
    }

}
